/**
 * Adree Theme — Navigation
 */

function initNavigation() {
  const header = document.querySelector('.js-site-header');
  const toggles = Array.from(document.querySelectorAll('.js-nav-toggle, .js-nav-toggle-floating'));
  const mobileQuery = window.matchMedia('(max-width: 1023px)');

  function closeSubmenus(nav = document) {
    nav.querySelectorAll('.menu-item-has-children.is-submenu-open').forEach((item) => {
      item.classList.remove('is-submenu-open');
    });

    nav.querySelectorAll('.submenu-toggle[aria-expanded="true"]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  function setupSubmenus() {
    document.querySelectorAll('.primary-navigation__list .menu-item-has-children').forEach((item, index) => {
      const link = item.querySelector(':scope > a');
      const submenu = item.querySelector(':scope > .sub-menu');

      if (!link || !submenu || item.querySelector(':scope > .submenu-toggle')) {
        return;
      }

      const submenuId = submenu.id || `submenu-${index + 1}-${Math.random().toString(36).slice(2, 8)}`;
      submenu.id = submenuId;
      submenu.style.setProperty('--submenu-height', `${submenu.scrollHeight}px`);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'submenu-toggle';
      button.setAttribute('aria-label', link.textContent.trim());
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', submenuId);
      link.insertAdjacentElement('afterend', button);

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!mobileQuery.matches) {
          return;
        }

        const isOpen = item.classList.toggle('is-submenu-open');
        button.setAttribute('aria-expanded', String(isOpen));
      });

      // Placeholder parent links behave as the dropdown trigger on touch layouts.
      if (link.getAttribute('href') === '#') {
        link.addEventListener('click', (event) => {
          if (!mobileQuery.matches) {
            return;
          }

          event.preventDefault();
          button.click();
        });
      }
    });
  }

  function closeNav(toggle) {
    const controls = toggle.getAttribute('aria-controls');
    const nav = controls ? document.getElementById(controls) : null;

    if (!nav) {
      return;
    }

    nav.classList.remove('is-open');
    closeSubmenus(nav);
    toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAllNavs(exceptToggle = null) {
    toggles.forEach((toggle) => {
      if (toggle !== exceptToggle) {
        closeNav(toggle);
      }
    });
  }

  // Wire up every nav toggle (base + floating) to its matching nav panel.
  toggles.forEach((toggle) => {
    const controls = toggle.getAttribute('aria-controls');
    const nav = controls ? document.getElementById(controls) : null;
    if (nav) {
      toggle.addEventListener('click', (event) => {
        event.stopPropagation();
        closeAllNavs(toggle);
        const isOpen = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
      });
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.site-header')) {
      closeAllNavs();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllNavs();
    }
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.sub-menu').forEach((submenu) => {
      submenu.style.setProperty('--submenu-height', `${submenu.scrollHeight}px`);
    });

    if (!mobileQuery.matches) {
      closeAllNavs();
    }
  });

  setupSubmenus();

  if (!header) {
    return;
  }

  let lastScrollY = 0;
  let ticking = false;
  const threshold = 80;

  function onScroll() {
    lastScrollY = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (lastScrollY > threshold) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
}

export { initNavigation };
